<div class="flex justify-between items-center pb-4">
  <h5 class="title-3 my-2">Manage External Users</h5>
  @if (dataTable) {
    <button
      pButton
      severity="secondary"
      type="button"
      label="Clear All Filters"
      icon="pi pi-filter-slash"
      data-test-id="clear-filters-button"
      [disabled]="isClearAllEnabled()"
      (click)="resetFilters()"
    ></button>
  }
</div>
<p-table
  #dt
  dataKey="email"
  class="table-parameters table-paginator"
  [value]="users"
  [columns]="cols"
  [paginator]="true"
  [(rows)]="rowsPerPage"
  [totalRecords]="totalRecords"
  [lazy]="true"
  (onLazyLoad)="loadData($event)"
  (onRowExpand)="onRowExpand($event)"
  [loading]="isLoading"
  [sortOrder]="defaultSortOrderOnLoad"
  [defaultSortOrder]="defaultSortOrder"
  [sortField]="defaultSortField"
  [resetPageOnSort]="true"
  [alwaysShowPaginator]="true"
  [rowsPerPageOptions]="[5, 10, 20]"
  [showCurrentPageReport]="true"
  currentPageReportTemplate="Showing {first}-{last} of {totalRecords} items"
>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th class="w-12"></th>
      <th pSortableColumn="email">
        <div class="flex items-center gap-2"></div>
        <div class="flex items-center gap-2">
          Business Email
          <p-sortIcon
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
            aria-label="Activate to sort"
            field="email"
          />
        </div>
      </th>
      <th pSortableColumn="displayName">
        <div class="flex items-center gap-2">
          Display Name
          <p-sortIcon
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
            aria-label="Activate to sort"
            field="displayName"
          />
        </div>
      </th>
      <th pSortableColumn="healthPlans">
        <div class="flex items-center gap-2">
          Health Plan
          <p-sortIcon
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
            aria-label="Activate to sort"
            field="healthPlans"
          />
        </div>
      </th>
      <th pSortableColumn="accountType">
        <div class="flex items-center gap-2">
          Account Type
          <p-sortIcon
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
            aria-label="Activate to sort"
            field="accountType"
          />
        </div>
      </th>
      <th pSortableColumn="createdOn">
        <div class="flex items-center gap-2">
          Created On
          <p-sortIcon
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
            aria-label="Activate to sort"
            field="createdOn"
          />
        </div>
      </th>
      <th pSortableColumn="isApproved">
        <div class="flex items-center gap-2">
          Active
          <p-sortIcon
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
            aria-label="Activate to sort"
            field="isApproved"
          />
        </div>
      </th>
      <th style="width: 30px"></th>
    </tr>

    <tr class="header-filter">
      <th class="w-12"></th>
      <th>
        <div class="relative autocomplete-icon-align">
          <p-iconfield>
            <p-inputicon class="pi pi-search" (click)="emailsLisInput.inputEL?.nativeElement.focus()"/>
            <p-autoComplete
              #emailsLisInput
              appendTo="body"
              inputStyleClass="table-filter"
              delay="500"
              placeholder="Search"
              [minQueryLength]="3"
              [suggestions]="filtersData"
              [(ngModel)]="email"
              (completeMethod)="fetchSuggestions($event.query, 'email')"
              (onSelect)="onAutocompleteSelect($event, 'email')"
              (onClear)="onClearAutocomplete('email')"
            />
          </p-iconfield>
        </div>
      </th>
      <th>
        <div class="relative autocomplete-icon-align">
          <p-iconfield>
            <p-inputicon class="pi pi-search" (click)="displayNameInput.inputEL?.nativeElement.focus()"/>
            <p-autoComplete
              #displayNameInput
              appendTo="body"
              styleClass="max-w-64"
              delay="500"
              [minLength]="3"
              [suggestions]="filtersData"
              [(ngModel)]="displayName"
              placeholder="Search"
              (completeMethod)="fetchSuggestions($event.query, 'displayName')"
              (onSelect)="onAutocompleteSelect($event, 'displayName')"
              (onClear)="onClearAutocomplete('displayName')"
            />
          </p-iconfield>
        </div>
      </th>
      <th>
        <p-multiSelect
          #healthPlansDropdown
          [options]="filteredHealthPlansList"
          [(ngModel)]="healthPlans"
          placeholder="Select"
          optionLabel="label"
          optionValue="value"
          [filter]="false"
          [showToggleAll]="true"
          [maxSelectedLabels]="3"
          class="max-w-64"
          appendTo="body"
          (onChange)="filterTable($event.value, 'healthPlans', 'in')"
        />
      </th>
      <th>
        <p-multiSelect
          #accountTypeDropdown
          [options]="filteredAccountTypesList"
          [(ngModel)]="accountType"
          placeholder="Select"
          optionLabel="label"
          optionValue="value"
          [filter]="true"
          filterPlaceHolder="Search"
          [showToggleAll]="true"
          [maxSelectedLabels]="3"
          class="max-w-64"
          appendTo="body"
          (onChange)="filterTable($event.value, 'accountType', 'in')"
        />
      </th>
      <th>
        <p-date-picker
          #calendarRef
          appendTo="body"
          dateFormat="mm/dd/yy"
          selectionMode="range"
          [(ngModel)]="createdOnRange"
          placeholder="mm/dd/yyyy - mm/dd/yyyy"
          [showIcon]="true"
          [readonlyInput]="true"
          [showButtonBar]="true"
          (onClearClick)="filterTable(null, 'createdOn', 'dateRangeWihoutOffset')"
          (onClose)="validateSelectedDates(createdOnRange, 'createdOn', 'in')"
        />
      </th>
      <th>
        <p-select
          [options]="activesList"
          [showClear]="true"
          placeholder="Filter"
          (onChange)="filterTable($event.value, 'isApproved', 'eq')"
          [(ngModel)]="active"
          appendTo="body"
        />
      </th>
      <th></th>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage" let-columns>
    <tr>
      <td [attr.colspan]="columns.length">
        <p>{{ isLoading ? 'Loading... please wait' : 'No record found' }}</p>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-user let-columns="columns" let-expanded="expanded">
    <tr>
      <td class="py-0! w-12">
        <button
          type="button"
          pButton
          class="transition-transform! duration-300"
          icon="pi pi-chevron-right"
          [rounded]="true"
          [text]="true"
          [pRowToggler]="user"
          [class]="{ 'rotate-90': expanded }"
        ></button>
      </td>
      <td>
        {{ user.email }}
      </td>
      <td>
        {{ user.displayName }}
      </td>
      <td>
        {{ user.healthPlans?.join(', ') }}
      </td>
      <td>
        {{ user.accountTypeDisplayName }}
      </td>
      <td>
        {{ user.createdOn | utcToLocal }}
      </td>
      <td>
        <div class="flex items-center gap-2 leading-none">
          <p-toggle-switch
            [ngModel]="user.isApproved"
            [accessEnableSubmit]="['ExternalUser.Write']"
            [appChangeUserStatusV2]="user"
            (statusChanged)="onUserStatusChanged()"
            title="Activate or In-Activate An User. On Activation Password Setup Email Will Be Sent."
          />
          <span>
                {{ user.isApproved ? 'Active' : 'Inactive' }}
              </span>
        </div>
      </td>
      <td class="py-0!">
        <button
          pButton
          type="button"
          class="p-button-text"
          icon="pi pi-pencil"
          title="Edit User"
          aria-label="Edit User"
          (click)="editUser(user.userId)"
        ></button>
      </td>
    </tr>
  </ng-template>

  <ng-template #expandedrow let-user>
    <tr>
      <td colspan="8">
        <app-external-user-provides [userId]="user.userId"></app-external-user-provides>
      </td>
    </tr>
  </ng-template>
</p-table>
